import React from "react";

export default function OpsIncidents() {
  return (
    <div className="rounded-2xl border border-slate-200 p-4">
      <div className="text-lg font-extrabold">Exceptions & Incidents</div>
      <p className="mt-1 text-sm text-slate-600">
        Next: incident cases with owner, severity, evidence, close resolution codes (audited).
      </p>
    </div>
  );
}
